import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../../auth/services/auth.service';
import { TokenService } from '@utilities/services/token.service';
import { OKTA_AUTH } from '@okta/okta-angular';
import { environment } from '../../../environments/environment';

export const combinedInterceptor: HttpInterceptorFn = (req, next) => {
  let request = req;
  const allowedOrigins = environment.oktaConfig.allowedOrigins;
  const oktaToken = inject(OKTA_AUTH).getAccessToken();
  const authService = inject(AuthService);
  const router = inject(Router);
  const tokenService = inject(TokenService);
  const token = tokenService.getActiveToken();

  if (token) {
    request = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }else{

    if (
      oktaToken &&
      !!allowedOrigins.find((origin) => req.url.includes(origin))
    ) {
      console.log({ oktaToken });
  
      request = req.clone({
        setHeaders: { Authorization: `Bearer ${oktaToken}` },
      });
    }
  
  }

  
  return next(request).pipe(
    catchError((response: HttpErrorResponse) => {
      if (response.status === 401) {
        const currentUrl = router.url;

        const isSharedFlow = currentUrl.startsWith('/shared-home');

        if (!isSharedFlow) {
          authService.logout();
          router.navigate(['']);
        }
      }

      return throwError(() => response);
    }),
  );
};
